import { render, staticRenderFns } from "./CommitSelectItem.vue?vue&type=template&id=c0f0ea52&scoped=true"
import script from "./CommitSelectItem.vue?vue&type=script&lang=ts"
export * from "./CommitSelectItem.vue?vue&type=script&lang=ts"
import style0 from "./CommitSelectItem.vue?vue&type=style&index=0&id=c0f0ea52&prod&scoped=true&lang=postcss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0f0ea52",
  null
  
)

export default component.exports